// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"625":"09d32e1d","963":"56ffcc1e"}[chunkId] + ".chunk.js";
};